import React, { useEffect, useContext } from "react";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import Loader from "../../../components/Loader/Loader";
import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import config from "../../../config/config";
import axios from "axios";
import moment from "moment";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import Select from "react-select";
import { Box, Stack } from "@mui/material";
import { AppContext } from "../../../context/AppContext";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import CurrencySymbols from "../../../common/CurrencySymbol";
import CommonDatePicker from "../../../components/DatePicker/CommonDatePicker";
import { toastSuccess } from "../../../common/Toast";
import ReportDate from "../../../components/Reports/ReportDate";

export const AccountsRunReport = () => {
  const {
    isManageSale,
    isManagePOSSale,
    dateFormate,
    CurrencySymbol,
    FractionDigits,
  } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [responseData, setResponseData] = useState([]);
  const token = localStorage.getItem("Token");
  const locationid = localStorage.getItem("Location");
  const searchParams = new URLSearchParams(window.location.search);

  const { id } = useParams();
  let iParam = searchParams.get("acc") || id;
  let iStartDate = searchParams.get("startdate") || "";
  let iEndDate = searchParams.get("enddate") || "";
  const navigate = useNavigate();

  const [chartOfAccountDropdown, setChartOfAccountDropdown] = useState([]);
  const [amount, setAmount] = useState(0);
  const [selectedAccount, setSelectedAccount] = useState("");
  const [AccountName, setAccountName] = useState("");

  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(16);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");


  console.log(enddate, startdate, AccountName, "date check");
  console.log(responseData, "responseData check");



  const handleEdit = (value, id, isExpanse, RecSaleID) => {
    console.log(value, id, isExpanse, RecSaleID, "handelEdit");
    // return
    if (isExpanse === "Expense" || isExpanse === "CC Credit") {
      navigate(`/Expense/${RecSaleID}`);
    }

    if (value == 8 || value == 9) {
      // navigate(`/manage-sales/${id}`)
      navigate(
        isManageSale == 1
          ? `/manage-sales/${id}`
          : isManagePOSSale == 1
          ? `/pos/${id}`
          : "#"
      );
    }

    if (value == 6 || value == 15) {
      navigate(`/Expense/${RecSaleID}`);
    }
    if (value == 5) {
      navigate(
        isManageSale == 1
          ? `/manage-receiving/${RecSaleID}`
          : isManagePOSSale == 1
          ? `/pos-receiving/${RecSaleID}`
          : "#"
      );
      // navigate(`/manage-receiving/${RecSaleID}`);
    }
    if (value == 3) {
      navigate(
        isManageSale == 1
          ? `/manage-receiving/${id}`
          : isManagePOSSale == 1
          ? `/pos-receiving/${id}`
          : "#"
      );
      // navigate(`/manage-receiving/${id}`);
    }

    if (value == 7) {
      navigate(`/receiving-paybills/${id}`);
    }

    if (value == 11) {
      navigate(`/receive-payment/${id}`);
    }

    if (value == 12) {
      navigate(`/bank-deposit/${id}`);
    }

    if (value == 13) {
      navigate(`/manage-transfer/${id}`);
    }

    if (value == 14) {
      navigate(`/journal-entry/${id}`);
    }
    
    if (value == 23) {
      navigate(`/manage-Items/${id}`);
    }

    if (value == 24) {
      navigate(`/new-inventory-count/${id}`);
    }
  };

  let accountTypeDropdownOption = [];
  const AccountDropdown = chartOfAccountDropdown?.map((u, i) => {
    accountTypeDropdownOption[i] = {
      label: u.Name,
      value: u.ID,
      amount: u.Amount,
      QuickbookId: u.QuickbookId,
      parentName: u.ParentName ? u.ParentName.trim() : "",
      AccountType: u.AccountType,
    };
  });
  
  const accountId = chartOfAccountDropdown?.some(
    (option) =>
      option.ID == (id == undefined ? 0 : id) &&
      (option.AccountName === "Accounts Receivable (A/R)" ||
        option.AccountName === "Accounts Payable (A/P)")
  );

  const isAP = chartOfAccountDropdown?.some(
    (option) =>
      option.ID == (id == undefined ? 0 : id) &&
      (option.AccountName === "Accounts Payable (A/P)")
  );


  let columns;
  let runningBalance = 0;

  if (AccountName == "Inventory Shrinkage") {
    columns = [
      {
        header: "Account",
        accessorKey: "Account",
        size: 150,
      },
      {
        header: "DATE",
        accessorKey: "Date",
        Cell: ({ row }) =>
          row.original.Date && row.original.Date != "00-00-0000"
            ? moment(row.original.Date).format(`${dateFormate.toUpperCase()}`)
            : "",
        size: 100,
      },
      {
        header: "TRANSACTION TYPE",
        accessorKey: "TransactionType",
        size: 170,
      },
      {
        header: "NUM",
        accessorKey: "Num",
        size: 170,
      },
      {
        header: "memo",
        accessorKey: "memo",
        size: 170,
      },
      {
        header: "Amount",
        accessorKey: "Amount",
        size: 150,
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        header: "Balance",
        Cell: ({ row }) => {
          runningBalance = runningBalance + Number(row.original.Amount) || 0;
          return `$${runningBalance}`;
        },

        size: 150,
        enableSorting: false,
        enableColumnFilter: false,
      },
    ];
  } else {
    columns = [
      {
        header: "DATE",
        accessorKey: "Date",
        Cell: ({ row }) => {
          return (
            <span>
              {row.original?.TransactionTypeID == 23 || row.original?.TransactionTypeID == 24 ? "" :
              <span
                title={
                  row.original?.SyncStatus > 0
                    ? "Synced"
                    : row.original?.QuickbookFailureReason
                }
              >
                <i
                  className={`fa fa-circle ${
                    row.original?.SyncStatus > 0
                      ? "text-success"
                      : "text-danger"
                  } mr-2`}
                ></i>
              </span>
                }
              {row.original.Date && row.original.Date != "00-00-0000"
                ? moment(row.original.Date).format(
                    `${dateFormate.toUpperCase()}`
                  )
                : ""}
            </span>
          );
        },
        size: 100,
      },
      {
        header: "TRANSACTION TYPE",
        accessorKey: "Type",
        size: 170,
      },
      {
        header: "NUM",
        accessorKey: "RefNo",
        Cell: ({ row }) => {
          return (
            <p
              onClick={() =>
                handleEdit(
                  row.original?.TransactionTypeID,
                  row.original?.TransactionTypeID == 23 || row.original?.TransactionTypeID == 24 ? row.original?.ItemsId : row.original?.ID, // 23 - Inventory Starting value
                  row.original?.Type,
                  row.original?.RecSaleID
                )
              }
              className="cursor-pointer"
            >
              {row.original.RefNo}
            </p>
          );
        },

        size: 100,
      },
      {
        header: "NAME",
        accessorKey: "Name",
        // size: 100,
      },
      {
        header: "MEMO/ DESCRIPTION",
        accessorKey: "Memo",
        // size: 100,
      },
      {
        header: "ACCOUNT",
        accessorKey: "ChartOfAccount",
        // size: 100,
      },
      {
        header: "AMOUNT",
        accessorKey: "AmountLine",
        Cell: ({ row }) =>
          CurrencySymbols(
            Number(row.original.isPayment > 0 ? row.original.Payment :  row.original.Deposit),
            CurrencySymbol,
            FractionDigits
          ),
        Footer: () => (
          <Stack>
            <Box>
              Total:{" "}
              {CurrencySymbols(Number(amount), CurrencySymbol, FractionDigits)}
            </Box>
          </Stack>
        ),
        size: 120,
      },
      ...(!accountId
        ? [
          {
            header: "BALANCE",
            accessorKey: "Balance",
            Cell: ({ row }) =>
              CurrencySymbols(
                Number(row.original.Balance),
                CurrencySymbol,
                FractionDigits
              ),
            size: 140,

        // Footer: () => (
        //   <Stack>
        //     <Box>
        //       Total:{" "}
        //       {`$${Number(amount).toLocaleString("en-US", {
        //         minimumFractionDigits: 2,
        //         maximumFractionDigits: 2,
        //       })}`}
        //     </Box>
        //   </Stack>
        // ),
      }] : []),
      
      // {
      //   header: "A/P Paid",
      //   accessorKey: "AP",
      //   size: 120,
      // },
      // {
      //   header: "A/R Paid",
      //   accessorKey: "AR",
      //   // Cell: ({ row }) => row.original.PayeeUserType === "Customer" ? row.original.Payee : '',
      //   size: 120,
      // },
      {
        header: "DueDate",
        accessorKey: "DueDate",
        Cell: ({ row }) =>
          row.original.DueDate && row.original.DueDate != "00-00-0000"
            ? moment(row.original.DueDate).format(
                `${dateFormate.toUpperCase()}`
              )
            : "",
        size: 100,
      },
      {
        header: "Credit",
        accessorKey: "Deposit",
        Cell: ({ row }) =>
          // "D:B:" +
          CurrencySymbols(
            Number(row.original.Deposit),
            CurrencySymbol,
            FractionDigits
          ),
        size: 120,
      },
      {
        header: "Debit",
        accessorKey: "Payment",
        size: 120,
        Cell: ({ row }) =>
          // "P:P:" +
          CurrencySymbols(
            Number(row.original.Payment),
            CurrencySymbol,
            FractionDigits
          ),
      },
      {
        header: "Last Modified Date Line",
        accessorKey: "CreatedModifiedDate",
        Cell: ({ row }) =>
          row.original.CreatedModifiedDate
            ? moment(row.original.CreatedModifiedDate).format(
                `${dateFormate.toUpperCase()} h:mm A`
              )
            : "",
        size: 140,
      },
      {
        header: "PAYEE",
        accessorKey: "Payee",
        Cell: ({ row }) =>
          row.original.Payee != null
            ? row.original.PayeeUserType === "Customer"
              ? row.original.Payee + " (Customer)"
              : row.original.PayeeUserType === "Supplier"
              ? row.original.Payee + " (Supplier)"
              : row.original.PayeeUserType === "Employee"
              ? row.original.Payee + " (Employee)"
              : ""
            : "-",
        // size: 200,
      },
    ];
  }

  function calculateBalance(entries) {
    let finalBalance = 0;
    const ArrayVRegister = [];

    entries.forEach((entry, index) => {
      // Update balance based on deposit and payment

      // if (entry?.AccountTypeID === 11) {
      //   finalBalance -= Number(entry?.Deposit);
      //   finalBalance += Number(entry?.Payment);
      // } else {
      //   finalBalance += Number(entry?.Deposit);
      //   finalBalance -= Number(entry?.Payment);
      // }

        // if (entry?.Type === "Credit Card") { // account payable
        if (isAP) { // account payable
        finalBalance -= Number(entry?.Deposit);
        finalBalance += Number(entry?.Payment);
        } else { // account receivable, Expense, 
        finalBalance += Number(entry?.Deposit);
        finalBalance -= Number(entry?.Payment);
        }

        // console.log(finalBalance, "finalBalance check");
      // Store the balance after each entry
      ArrayVRegister.push({
        ...entry,
        entryNumber: index + 1,
        Balance: finalBalance,
        ...(isAP ? {
        Deposit: `${-1*entry?.Deposit}`,
        Payment: entry?.Payment 
        } : {
        Deposit: entry?.Deposit,
        Payment: `${-1*entry?.Payment}`,
        })
      });
    });

    return {
      OrderByDesc: ArrayVRegister,
      finalBalance,
    };
  }

  const reportPeriodAPI = () => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        let reportdropdown = [];
        const data2 = res.data.ResponseData?.map(
          (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
        );
        setSelectedDate(reportdropdown);
        return res;
      });
  };

  useEffect(() => {
    AccountSaveAPI();
  }, [id]);

  useEffect(() => {
    reportPeriodAPI();
  }, []);

  const AccountSaveAPI = async () => {
    // chart of Account Dropdown for account id
    await axios
      .get(`${config.accountingBaseUrl}/chartofaccounts/accountddl`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setChartOfAccountDropdown(res.data.ResponseData);

        setAccountName(
          res.data?.ResponseData?.find((el) => el.ID == id)?.AccountName
        );
        setSelectedAccount(
          res.data?.ResponseData?.find((el) => el.ID == id)?.Name
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };



  const onGridReady = () => {
    if (AccountName) {
      console.log(AccountName, "584");
      if (selectReport == 2 && (!startdate || !enddate)) {
        return;
      }
      setLoading(true);

      let SDate = startdate !== "" ? startdate : iStartDate;
      let EDate = enddate !== "" ? enddate : iEndDate;
      let AccId = iParam > 0 ? iParam : id;
      
      // old api: accountviewregister
      axios
        .get(
          `${config.accountingBaseUrl}/chartofaccounts/accountviewregisterV2?searchtext=&transactiontype=1&customerid=0&supplierid=0&employeeid=0&startdate=${SDate}&enddate=${EDate}&locationid=${locationid}&accountid=${AccId}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log("response ==>", res.data.ResponseData);
          const newarr = res.data.ResponseData?.map((el) => {
            return {
              ...el,
              showDelete: true,
              Payment: el?.Payment ? parseFloat(el?.Payment).toFixed(2) : 0,
              Deposit: el?.Deposit ? parseFloat(el?.Deposit).toFixed(2) : 0,
              showAll: el.Type === "Expense" ? true : false,
              TransactionTypeID:
              el?.isCreditCard == 1 ? 21 : el.TransactionTypeID,
              Type: el?.isCreditCard == 1 ? "CC Credit" : el.Type,
            };
          });

          // const balance = res.data.ResponseData.reduce((acc, curr) => {
          //   return acc + Number(curr.AmountLine);
          // }, 0);

          // console.log(balance, "balance data check");
          const FinalData = calculateBalance(newarr);

          // setResponseData(res.data.ResponseData);
          setResponseData(FinalData?.OrderByDesc);

          // const account = res.data.ResponseData[0];
          // const name = account?.ChartOfAccount;
          // const type = account?.ChartOfAccountType;
          // setAccountName(
          //   name && type ? `${name} (${type})` : name || type || ""
          // );
          // setSelectedAccount(
          //   name && type ? `${name} (${type})` : name || type || ""
          // );
          setAmount(Number(FinalData?.finalBalance || 0).toFixed(2));
          // }

          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    }
  };

  const Inventoryshrinkage = () => {
    if (AccountName) {
      setLoading(true);
      axios
        .get(
          `${config.accountingBaseUrl}/chartofaccounts/InvShrikageReport?currentorder=desc&ordercolumn=&pagesize=&pagenumber=1&filtertext=&startdate=${startdate}&enddate=${enddate}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          setLoading(false);
          setResponseData(res.data.ResponseData);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    }
  };

  const handleNewInputChange = (event, fieldName) => {
    console.log(event, fieldName, "186");
    if (event?.value) {
      navigate(`/account-report/${event?.value}`);
    }
  };

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
    if (event?.value === 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };

  useEffect(() => {
    if (AccountName == "Inventory Shrinkage") {
      Inventoryshrinkage();
    }
    if (AccountName !== "Inventory Shrinkage" && AccountName !== "") {
      onGridReady();
    }
  }, [startdate, enddate, AccountName]); // id

  return (
    <>
      <Sidebar />
      <Loader loading={loading} />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "11px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/accounting">Accounting</Link>
                </li>
                <li className="breadcrumb-item active">{selectedAccount}</li>
              </ul>
            </div>
          </div>
          <div className="">
            <div className="">
              <div className="col-lg-12 col-md-6 col-sm-12 d-flex justify-content-between">
                <div className="d-flex gap-2">
                  <div>
                    <div className="col-form-label">Account</div>
                    <div style={{ width: "290px" }} className="col-md-11 z-3">
                      <Select
                        onChange={(event) =>
                          handleNewInputChange(event, "AccountID")
                        }
                        value={accountTypeDropdownOption?.find(
                          (el) => el?.value == iParam //id
                        )}
                        options={accountTypeDropdownOption}
                        backspaceRemovesValue={false}
                        controlShouldRenderValue={true}
                        hideSelectedOptions={true}
                        isClearable={false}
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        placeholder="Account"
                        id="AccountId"
                        name="AccountId"
                        className="custom-search-select"
                        formatOptionLabel={({ label, parentName, AccountType }) => (
                      <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                        <span>{label}</span>
                        <span style={{ fontStyle: "italic", color: "#666", marginLeft: "1rem" }}>
                          {parentName ? `Sub-account of ${parentName}` : AccountType}
                        </span>
                      </div>
                    )}
                      />
                    </div>
                  </div>
                  <div className={selectReport == 1 ? "col-sm-4" : "col-sm-3"}>
                    <label className="col-form-label col-md-12 form-label p-lg-medium">
                      Report period
                    </label>
                    <div className="row">
                      <div className="col-md-12 z-3">
                        <Select
                          styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                          options={selectedDate}
                          backspaceRemovesValue={false}
                          controlShouldRenderValue={true}
                          hideSelectedOptions={true}
                          // isClearable={true}
                          name="Reportperiod"
                          id="Reportperiod"
                          value={selectedDate.find(
                            (e) => e.value === selectReport
                          )}
                          onChange={(event) => {
                            handleDropdownChange(event);
                          }}
                          className="custom-search-select"
                        ></Select>
                      </div>
                    </div>
                  </div>
                  {selectReport !== 1 && (
                    <div className="col-sm-4">
                      <ReportDate
                        callback={callback}
                        selectReport={selectReport}
                        showhidecomponent={
                          selectReport == 2 ||
                          selectReport == 3 ||
                          selectReport == 4 ||
                          selectReport == 5 ||
                          selectReport == 6 ||
                          selectReport == 7 ||
                          selectReport == 8 ||
                          selectReport == 9 ||
                          selectReport == 10 ||
                          selectReport == 11 ||
                          selectReport == 12 ||
                          selectReport == 13 ||
                          selectReport == 14 ||
                          selectReport == 15 ||
                          selectReport == 16 ||
                          selectReport == 17 ||
                          selectReport == 18 ||
                          selectReport == 19 ||
                          selectReport == 20 ||
                          selectReport == 21 ||
                          selectReport == 22 ||
                          selectReport == 23 ||
                          selectReport == 24 ||
                          selectReport == 25 ||
                          selectReport == 26 ||
                          selectReport == 27 ||
                          selectReport == 28 ||
                          selectReport == 29 ||
                          selectReport == 30 ||
                          selectReport == 31
                            ? true
                            : false
                        }
                      />
                    </div>
                  )}
                </div>
                {accountId && (
                  <div className="text-end">
                    <h6 className="p">${amount ? amount : 0}</h6>
                    <p class="p-medium">Balance</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="card mt-5">
            <div className="card-body">
              <div className="container">
                <div className="col-md-12 text-center" id="header">
                  {/* <h2>SonarPos</h2> */}
                  <h6>{selectedAccount}</h6>
                </div>
              </div>

              <div className="table-responsive">
                <div className="table mt-3">
                  <CommonMatrialReactTable
                    columns={columns}
                    data={responseData}
                    hodiExport={true}
                    enableRowSelection={false}
                    muiTableBodyRowProps={({ row }) => ({
                      onClick: () =>
                        handleEdit(
                          row.original.TransactionTypeID,
                          (row.original.TransactionTypeID == 23 || row.original.TransactionTypeID == 24) ? row.original.ItemsId : row.original.ID,
                          row.original.Type,
                          row.original.RecSaleID
                        ),
                      // selected: rowSelection[row.id],
                      sx: {
                        cursor: "pointer",
                      },
                    })}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
